import { render, staticRenderFns } from "./RadishTableMax.vue?vue&type=template&id=0a57325e&"
import script from "./RadishTableMax.vue?vue&type=script&lang=js&"
export * from "./RadishTableMax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports